import { Injectable } from "@angular/core";
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

@Injectable({
	providedIn: "root",
})
export class PdfReaderService {
	constructor() {}

	public async readPdf(pdfFile) {
		// const pdfFile = event.target.files[0];
		const reader = new FileReader();
		const fileData = await new Promise<string>((resolve, reject) => {
			reader.onload = (event) => {
				resolve(event.target?.result as string);
			};
			reader.onerror = (event) => {
				reject(event.target?.error);
			};
			reader.readAsDataURL(pdfFile);
		});

		const loadingTask = pdfjsLib.getDocument(fileData);
		const pdf = await loadingTask.promise;

		const countPromises = []; // collecting all page promises
		for (let i = 1; i <= pdf.numPages; i++) {
			const page = await pdf.getPage(i);
			const textContent = await page.getTextContent();
			const pageText = textContent.items
				.filter((item) => item["str"] !== undefined)
				.map((item) => item["str"])
				.join("");
			countPromises.push(pageText);
		}

		const pageContents = await Promise.all(countPromises);
		return pageContents.join("");
	}
}
